import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode, localeOption } from 'primereact/api';
import { getContrastTextColor } from './FuncionesGenericas';
import { Tag } from 'primereact/tag';

export const getOpcionesFiltroTexto = () => [
    { label: localeOption('contains'), value: FilterMatchMode.CONTAINS },
    { label: localeOption('startsWith'), value: FilterMatchMode.STARTS_WITH },
    { label: localeOption('endsWith'), value: FilterMatchMode.ENDS_WITH },
    { label: localeOption('equals'), value: FilterMatchMode.EQUALS },
    { label: localeOption('notEquals'), value: FilterMatchMode.NOT_EQUALS }
];

export const getOpcionesFiltroNumerico = () => [
    { label: localeOption('equals'), value: FilterMatchMode.EQUALS },
    { label: localeOption('notEquals'), value: FilterMatchMode.NOT_EQUALS },
    { label: localeOption('lt'), value: FilterMatchMode.LESS_THAN },
    { label: localeOption('lte'), value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    { label: localeOption('gt'), value: FilterMatchMode.GREATER_THAN },
    { label: localeOption('gte'), value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }
];

export const getOpcionesFiltroFecha = () => [
    { label: localeOption('dateIs'), value: FilterMatchMode.DATE_IS },
    { label: localeOption('dateIsNot'), value: FilterMatchMode.DATE_IS_NOT },
    { label: localeOption('dateBefore'), value: FilterMatchMode.DATE_BEFORE },
    { label: localeOption('dateAfter'), value: FilterMatchMode.DATE_AFTER }
];

export const getOpcionesFiltroMultiSelect = () => [
    { label: 'Contenido en', value: FilterMatchMode.IN },
    { label: 'No contenido en', value: FilterMatchMode.NOT_IN }
];

export const getOpcionesFiltroBoolean = () => [
];

export const formatoMoneda = (valor) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(valor || 0);
};

export const formatoFecha = (valor) => {
    if (!valor) return '';
    // Ajusta 'es-EC' a tu localidad si es necesario
    return new Date(valor).toLocaleDateString('es-EC');
};

export const FiltroFecha = (options) => (
    <Calendar value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} dateFormat="yy-mm-dd" placeholder="Seleccionar" className="p-column-filter w-full p-inputtext-sm" showButtonBar readOnlyInput />
);

export const FiltroNumerico = (options, placeholder) => (
    <InputNumber value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} mode="decimal" minFractionDigits={0} maxFractionDigits={2} className="p-column-filter w-full p-inputtext-sm" placeholder={placeholder || "0"} useGrouping={false} />
);

// Recibe las opciones del dropdown (catálogo)
export const FiltroMultiSelect = (options, catalogoOpciones) => {
    const itemTemplate = (option) => {
        if (option.back_color) {
            const backgroundColor = `#${option.back_color.replace('#', '')}`;
            const textColor = getContrastTextColor(backgroundColor);
            return (
                <div style={{ padding: '4px 8px', borderRadius: '4px', backgroundColor: backgroundColor, color: textColor, fontSize: '0.85rem', fontWeight: 'bold', display: 'inline-block' }}>
                    {option.label}
                </div>
            );
        }
        return option.label;
    };
    const onChangeHandler = (e) => {
        const vals = e.value;
        if (!vals || vals.length === 0) {
            // Limpiamos el filtro pasando null
            options.filterApplyCallback(null);
        } else {
            // Aplicamos los valores seleccionados
            options.filterApplyCallback(vals);
        }
    };

    return (
        <MultiSelect value={options.value || []} options={catalogoOpciones} onChange={onChangeHandler} itemTemplate={itemTemplate} display="chip" optionLabel="label" optionValue="value" placeholder="Todos" className="p-column-filter" maxSelectedLabels={1} style={{ width: '100%' }} />
    );
};

export const FiltroBoolean = (options) => {
    return (
        <div className="flex gap-2 justify-content-center">
            <Tag icon="pi pi-check" severity={options.value === true ? 'success' : 'secondary'} value="Sí" style={{ cursor: 'pointer', opacity: options.value === true ? 1 : 0.5 }} onClick={() => options.filterApplyCallback(options.value === true ? null : true)} />
            <Tag icon="pi pi-times" severity={options.value === false ? 'danger' : 'secondary'} value="No" style={{ cursor: 'pointer', opacity: options.value === false ? 1 : 0.5 }} onClick={() => options.filterApplyCallback(options.value === false ? null : false)} />
        </div>
    );
};

export const FiltroTexto = (options, placeholder) => (
    <InputText value={options.value || ''} onChange={(e) => options.filterApplyCallback(e.target.value)} placeholder={placeholder} className="p-column-filter w-full p-inputtext-sm" />
);

/**
 * Determina el MatchMode por defecto basado en la configuración de la columna.
 */
export const obtenerMatchMode = (config) => {
    // Si el modelo define uno explícito, lo escoge.
    if (config.matchMode) return config.matchMode;
    // Reglas de inferencia por tipo de dato
    if (config.isNumeric || config.isCurrency) return FilterMatchMode.EQUALS;
    if (config.isMultiselect) return FilterMatchMode.IN;
    if (config.isDate) return FilterMatchMode.DATE_IS;
    if (config.isBoolean) return FilterMatchMode.EQUALS;
    // Fallback por defecto (Texto)
    return FilterMatchMode.CONTAINS;
};